[
  {
    "path": "cookie-hinweise",
    "redirectTo": "/datenschutz",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/videochats-sind-zoom-und-skype-sicher",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/videochats-sind-zoom-und-skype-sicher",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/worauf-eltern-bei-kinderbildern-im-netz-achten-sollten",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/worauf-eltern-bei-kinderbildern-im-netz-achten-sollten",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/so-schuetzt-du-dich-in-oeffentlichen-wlan-netzwerken-vor-hackern-und-datendiebstahl",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/so-schuetzt-du-dich-in-oeffentlichen-wlan-netzwerken-vor-hackern-und-datendiebstahl",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/wie-kann-ich-meine-privatsphaere-und-anonymitaet-im-internet-schuetzen",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/wie-kann-ich-meine-privatsphaere-und-anonymitaet-im-internet-schuetzen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/welche-suchmaschinen-und-informationsseiten-eignen-sich-fuer-kinder",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/welche-suchmaschinen-und-informationsseiten-eignen-sich-fuer-kinder",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/was-sind-in-app-kaeufe-und-lootboxen-sind-sie-bei-kindern-rechtswirksam",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/was-sind-in-app-kaeufe-und-lootboxen-sind-sie-bei-kindern-rechtswirksam",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/was-ist-der-digitale-fussabdruck-und-wie-lassen-sich-die-daten-schuetzen",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/was-ist-der-digitale-fussabdruck-und-wie-lassen-sich-die-daten-schuetzen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/tipps-zur-sicheren-nutzung-des-internets",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/tipps-zur-sicheren-nutzung-des-internets",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/so-erstellst-und-verwaltest-du-sichere-passwoerter",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/so-erstellst-und-verwaltest-du-sichere-passwoerter",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/datenschutz-im-internet-so-gehst-du-mit-persoenlichen-daten-im-internet-richtig-um",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/datenschutz-im-internet-so-gehst-du-mit-persoenlichen-daten-im-internet-richtig-um",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/cyber-grooming-wie-kann-man-kinder-und-jugendliche-davor-schuetzen",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/cyber-grooming-wie-kann-man-kinder-und-jugendliche-davor-schuetzen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/identifizierung-und-umgang-mit-deepfakes-im-internet",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/identifizierung-und-umgang-mit-deepfakes-im-internet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/was-ist-eine-zwei-faktor-authentifizierung-2fa-und-wie-richtet-man-sie-ein",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/was-ist-eine-zwei-faktor-authentifizierung-2fa-und-wie-richtet-man-sie-ein",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/internet-kindersicherung-so-schuetzt-du-deine-kinder-vor-online-gefahren",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/internet-kindersicherung-so-schuetzt-du-deine-kinder-vor-online-gefahren",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/passwortmanager-so-verwaltest-du-sichere-passwoerter-richtig",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/passwortmanager-so-verwaltest-du-sichere-passwoerter-richtig",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/ist-snapchat-kindersicher-so-richtest-du-snapchat-sicher-ein-kindersicherung-einstellen",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/ist-snapchat-kindersicher-so-richtest-du-snapchat-sicher-ein-kindersicherung-einstellen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/gefahr-in-social-media-so-schuetzt-du-dich-vor-hackern-und-betruegern",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/gefahr-in-social-media-so-schuetzt-du-dich-vor-hackern-und-betruegern",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/datensicherheit-so-schuetzt-du-deine-persoenlichen-daten-im-internet",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/datensicherheit-so-schuetzt-du-deine-persoenlichen-daten-im-internet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/kleiner-klick-grosser-schaden-so-findest-du-hilfe-bei-onlinebetrug",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/kleiner-klick-grosser-schaden-so-findest-du-hilfe-bei-onlinebetrug",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/schutz-vor-cyberstalking-belaestigung-durch-dritte-im-internet",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/schutz-vor-cyberstalking-belaestigung-durch-dritte-im-internet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/identitaetsdiebstahl-vermeiden-tipps-zum-schutz-persoenlicher-daten",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/identitaetsdiebstahl-vermeiden-tipps-zum-schutz-persoenlicher-daten",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/identitaetsdiebstahl-versicherung/ist-revenge-porn-strafbar-und-wie-kann-ich-dagegen-vorgehen",
    "redirectTo": "/identitaetsdiebstahl-versicherung/ratgeber/ist-revenge-porn-strafbar-und-wie-kann-ich-dagegen-vorgehen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/",
    "redirectTo": "/cyberversicherung/ratgeber/",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/bildung-auf-social-media-die-vorteile-und-nachteile-beim-lernen-auf-tiktok-und-youtube",
    "redirectTo": "/cyberversicherung/ratgeber/bildung-auf-social-media-die-vorteile-und-nachteile-beim-lernen-auf-tiktok-und-youtube",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/youtube-welche-gefahren-fuer-kinder-bestehen",
    "redirectTo": "/cyberversicherung/ratgeber/youtube-welche-gefahren-fuer-kinder-bestehen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/bereal-risiken-ist-bereal-eine-sichere-social-media-plattform",
    "redirectTo": "/cyberversicherung/ratgeber/bereal-risiken-ist-bereal-eine-sichere-social-media-plattform",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/ist-discord-sicher-was-eltern-ueber-discord-wissen-muessen",
    "redirectTo": "/cyberversicherung/ratgeber/ist-discord-sicher-was-eltern-ueber-discord-wissen-muessen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/sichere-online-spiele-die-besten-tipps-fuer-sicheres-online-gaming",
    "redirectTo": "/cyberversicherung/ratgeber/sichere-online-spiele-die-besten-tipps-fuer-sicheres-online-gaming",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/ist-roblox-sicher-fuer-kinder-das-muessen-eltern-ueber-die-spieleplattform-wissen",
    "redirectTo": "/cyberversicherung/ratgeber/ist-roblox-sicher-fuer-kinder-das-muessen-eltern-ueber-die-spieleplattform-wissen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/minecraft-ab-welchem-alter-ist-das-online-spiel-fuer-kinder-geeignet",
    "redirectTo": "/cyberversicherung/ratgeber/minecraft-ab-welchem-alter-ist-das-online-spiel-fuer-kinder-geeignet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/fortnite-altersfreigabe-das-sollten-eltern-ueber-das-online-spiel-wissen",
    "redirectTo": "/cyberversicherung/ratgeber/fortnite-altersfreigabe-das-sollten-eltern-ueber-das-online-spiel-wissen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/altersfreigabe-bei-brawl-stars-was-eltern-ueber-das-online-spiel-wissen-muessen",
    "redirectTo": "/cyberversicherung/ratgeber/altersfreigabe-bei-brawl-stars-was-eltern-ueber-das-online-spiel-wissen-muessen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/altersfreigabe-bei-among-us-ist-das-beliebte-online-spiel-sicher-fuer-kinder",
    "redirectTo": "/cyberversicherung/ratgeber/altersfreigabe-bei-among-us-ist-das-beliebte-online-spiel-sicher-fuer-kinder",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/altersfreigabe-ist-tiktok-gefaehrlich-fuer-kinder-und-jugendliche",
    "redirectTo": "/cyberversicherung/ratgeber/altersfreigabe-ist-tiktok-gefaehrlich-fuer-kinder-und-jugendliche",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/livestreams-ab-wie-viel-jahren-ist-twitch-fuer-kinder-und-jugendliche-geeignet",
    "redirectTo": "/cyberversicherung/ratgeber/livestreams-ab-wie-viel-jahren-ist-twitch-fuer-kinder-und-jugendliche-geeignet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/datenschutz-bei-tiktok-welche-risiken-gibt-es",
    "redirectTo": "/cyberversicherung/ratgeber/datenschutz-bei-tiktok-welche-risiken-gibt-es",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/whatsapp-kindersicherung-so-machst-du-den-messenger-fuer-kinder-und-jugendliche-sicher",
    "redirectTo": "/cyberversicherung/ratgeber/whatsapp-kindersicherung-so-machst-du-den-messenger-fuer-kinder-und-jugendliche-sicher",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cyberversicherung/ist-instagram-fuer-kinder-und-jugendliche-geeignet",
    "redirectTo": "/cyberversicherung/ratgeber/ist-instagram-fuer-kinder-und-jugendliche-geeignet",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/gefahren-beim-chatten-welche-risiken-bergen-chatraeume",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/gefahren-beim-chatten-welche-risiken-bergen-chatraeume",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/schoenheitsideale-auf-social-media-plattformen-gefahr-fuer-kinder-und-jugendliche",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/schoenheitsideale-auf-social-media-plattformen-gefahr-fuer-kinder-und-jugendliche",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/social-media-challenges-welche-gefahren-lauern",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/social-media-challenges-welche-gefahren-lauern",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/schutz-vor-cybermobbing-diese-rechtlichen-moeglichkeiten-gibt-es",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/schutz-vor-cybermobbing-diese-rechtlichen-moeglichkeiten-gibt-es",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/praevention-von-cybermobbing-wie-ein-bestmoeglicher-schutz-entsteht",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/praevention-von-cybermobbing-wie-ein-bestmoeglicher-schutz-entsteht",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/cybermobbing-unterrichtsmaterial-tipps-zur-praeventionsarbeit-an-schulen-gegen-cybermobbing",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/cybermobbing-unterrichtsmaterial-tipps-zur-praeventionsarbeit-an-schulen-gegen-cybermobbing",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/was-kann-man-gegen-cybermobbing-tun  Status Code: 301",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/was-kann-man-gegen-cybermobbing-tun",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/was-ist-hatespeech-und-wie-kann-man-sich-dagegen-schuetzen",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/was-ist-hatespeech-und-wie-kann-man-sich-dagegen-schuetzen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/cybermobbing-erfahrungen-wie-man-mit-den-negativen-folgen-von-cybermobbing-umgehen-kann",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/cybermobbing-erfahrungen-wie-man-mit-den-negativen-folgen-von-cybermobbing-umgehen-kann",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/so-gehst-du-mit-cybermobbing-in-sozialen-netzwerken-wie-facebook-instagram-und-twitter-um",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/so-gehst-du-mit-cybermobbing-in-sozialen-netzwerken-wie-facebook-instagram-und-twitter-um",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/was-ist-cybermobbing-und-wie-kann-man-es-bekaempfen",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/was-ist-cybermobbing-und-wie-kann-man-es-bekaempfen",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/anzeichen-von-cybermobbing-so-erkennst-du-dass-jemand-opfer-von-cybermobbing-ist",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/anzeichen-von-cybermobbing-so-erkennst-du-dass-jemand-opfer-von-cybermobbing-ist",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/cybermobbing-versicherung/die-rolle-der-eltern-beim-schutz-vor-cybermobbing",
    "redirectTo": "/cybermobbing-versicherung/ratgeber/die-rolle-der-eltern-beim-schutz-vor-cybermobbing",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/",
    "redirectTo": "/handyversicherung/ratgeber/",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/handy-defekt-welche-arten-von-defekten-es-bei-handys-gibt-und-wie-du-sie-beheben-kannst",
    "redirectTo": "/handyversicherung/ratgeber/handy-defekt-welche-arten-von-defekten-es-bei-handys-gibt-und-wie-du-sie-beheben-kannst",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/handy-display-defekt-was-man-bei-einem-kaputten-handy-display-tun-kann",
    "redirectTo": "/handyversicherung/ratgeber/handy-display-defekt-was-man-bei-einem-kaputten-handy-display-tun-kann",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/iphone-defekt-welche-arten-von-defekten-es-bei-iphones-gibt-und-wie-man-sie-beheben-kann",
    "redirectTo": "/handyversicherung/ratgeber/iphone-defekt-welche-arten-von-defekten-es-bei-iphones-gibt-und-wie-man-sie-beheben-kann",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/kindersicheres-smartphone-wie-eltern-smartphones-fuer-ihre-kinder-sicher-einrichten",
    "redirectTo": "/handyversicherung/ratgeber/kindersicheres-smartphone-wie-eltern-smartphones-fuer-ihre-kinder-sicher-einrichten",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/handyversicherung/wasserschaden-beim-handy-was-kann-ich-tun",
    "redirectTo": "/handyversicherung/ratgeber/wasserschaden-beim-handy-was-kann-ich-tun",
    "pathMatch": "full",
    "statusCode": "301"
  },
  {
    "path": "ratgeber/online-shopping-versicherung/online-shopping-sicher-einkaufen-und-bezahlen-im-netz",
    "redirectTo": "/handyversicherung/ratgeber/wasserschaden-beim-handy-was-kann-ich-tun",
    "pathMatch": "full",
    "statusCode": "301"
  }
]